import { render, staticRenderFns } from "./box11.vue?vue&type=template&id=2cc259bb&scoped=true&"
import script from "./box11.vue?vue&type=script&lang=js&"
export * from "./box11.vue?vue&type=script&lang=js&"
import style0 from "./box11.vue?vue&type=style&index=0&id=2cc259bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc259bb",
  null
  
)

export default component.exports